import { throwErrorMessage } from 'dashboard/store/utils/api';
import { emitter } from 'shared/helpers/mitt';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

// O unread_count local só zera 4s depois (setTimeout abaixo). Evita descontar
// a mesma conversa duas vezes se ela for marcada como lida de novo nesse meio tempo.
const pendingReadIds = new Set();

export default {
  markMessagesRead: async ({ commit, dispatch, getters }, data) => {
    const chat = getters.getConversationById(data.id);
    const wasUnread = chat?.unread_count > 0 && !pendingReadIds.has(data.id);
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      if (wasUnread) {
        pendingReadIds.add(id);
        // Desconta na hora; a recontagem do servidor (abaixo) corrige diferenças
        dispatch('conversationStats/adjustUnreadCount', -1, { root: true });
        emitter.emit('fetch_conversation_stats');
      }
      setTimeout(() => {
        commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
        pendingReadIds.delete(id);
      }, 4000);
    } catch (error) {
      pendingReadIds.delete(data.id);
    }
  },

  markMessagesUnread: async ({ commit, dispatch }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
      if (unreadCount > 0) {
        dispatch('conversationStats/adjustUnreadCount', 1, { root: true });
        emitter.emit('fetch_conversation_stats');
      }
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
